// AUTO-GENERATED SQL Builder (V40 Final) for InvoiceLine
import { 
  SqlField, 
  SqlExp, 
  SqlExpChain, 
  SqlFn, 
  SqlLiteral, 
  SqlSubQuery, 
  SqlApplyColumn, 
  SqlNavHybrid, 
  createNavHybrid 
} from '../utils/sql-core';
import { SqlAst } from '../utils/sql-ast';

export class InvoiceLineSql {
  private ast = new SqlAst('InvoiceLine', 'invoiceLine');
  public readonly main: any = {};

  public invoiceRevisionId: SqlField;
  public bookingPackageId: SqlField;
  public description: SqlField;
  public quantity: SqlField;
  public unitPrice: SqlField;
  public lineTotal: SqlField;
  public sortOrder: SqlField;
  public bookingPackage: SqlNavHybrid;
  public createdByUser: SqlNavHybrid;
  public invoiceRevision: SqlNavHybrid;
  public updatedByUser: SqlNavHybrid;
  public id: SqlField;
  public isDeleted: SqlField;
  public createdBy: SqlField;
  public createdDate: SqlField;
  public updatedBy: SqlField;
  public updatedDate: SqlField;

  constructor() {
    this.invoiceRevisionId = new SqlField('invoiceLine', 'invoiceRevisionId', 'invoiceRevision', 'id', 'invoiceLine_invoiceRevision');
    this.bookingPackageId = new SqlField('invoiceLine', 'bookingPackageId', 'bookingPackage', 'id', 'invoiceLine_bookingPackage');
    this.description = new SqlField('invoiceLine', 'description', '', 'id', 'invoiceLine_description');
    this.quantity = new SqlField('invoiceLine', 'quantity', '', 'id', 'invoiceLine_quantity');
    this.unitPrice = new SqlField('invoiceLine', 'unitPrice', '', 'id', 'invoiceLine_unitPrice');
    this.lineTotal = new SqlField('invoiceLine', 'lineTotal', '', 'id', 'invoiceLine_lineTotal');
    this.sortOrder = new SqlField('invoiceLine', 'sortOrder', '', 'id', 'invoiceLine_sortOrder');
    this.bookingPackage = createNavHybrid('invoiceLine', 'invoiceLine_bookingPackage', 'BookingPackage');
    this.createdByUser = createNavHybrid('invoiceLine', 'invoiceLine_createdByUser', 'User');
    this.invoiceRevision = createNavHybrid('invoiceLine', 'invoiceLine_invoiceRevision', 'InvoiceRevision');
    this.updatedByUser = createNavHybrid('invoiceLine', 'invoiceLine_updatedByUser', 'User');
    this.id = new SqlField('invoiceLine', 'id', '', 'id', 'invoiceLine_id');
    this.isDeleted = new SqlField('invoiceLine', 'isDeleted', '', 'id', 'invoiceLine_isDeleted');
    this.createdBy = new SqlField('invoiceLine', 'createdBy', '', 'id', 'invoiceLine_createdBy');
    this.createdDate = new SqlField('invoiceLine', 'createdDate', '', 'id', 'invoiceLine_createdDate');
    this.updatedBy = new SqlField('invoiceLine', 'updatedBy', '', 'id', 'invoiceLine_updatedBy');
    this.updatedDate = new SqlField('invoiceLine', 'updatedDate', '', 'id', 'invoiceLine_updatedDate');

    for (const k of Object.keys(this)) {
      const v = (this as any)[k];
      if (v instanceof SqlField) this.main[k] = v;
    }
  }

  // SELECT
  select(fn:(x:InvoiceLineSql)=>any) {
    this.ast.addSelectObject(fn(this));
    return this;
  }

  // WHERE
  where(fn:(x:InvoiceLineSql)=>SqlExp | SqlExpChain) {
    this.ast.addWhere(fn(this));
    return this;
  }
  and(fn:(x:InvoiceLineSql)=>SqlExp | SqlExpChain) {
    this.ast.addWhere(fn(this));
    return this;
  }
  or(fn:(x:InvoiceLineSql)=>SqlExp | SqlExpChain) {
    this.ast.addOr(fn(this));
    return this;
  }

  // JOIN
  join(fn:(x:InvoiceLineSql)=>SqlField | SqlNavHybrid) {
    const f = fn(this);
    this.ast.addJoin(f instanceof SqlNavHybrid ? f.asSqlField() : f);
    return this;
  }
  leftJoin(fn:(x:InvoiceLineSql)=>SqlField | SqlNavHybrid) {
    const f = fn(this);
    this.ast.addJoin(f instanceof SqlNavHybrid ? f.asSqlField() : f, 'LEFT');
    return this;
  }
  rightJoin(fn:(x:InvoiceLineSql)=>SqlField | SqlNavHybrid) {
    const f = fn(this);
    this.ast.addJoin(f instanceof SqlNavHybrid ? f.asSqlField() : f, 'RIGHT');
    return this;
  }

  // AND JOIN
  andJoin(fn:(l:any,r:any)=>SqlExp | SqlExpChain) {
    const last = this.ast.joins[this.ast.joins.length - 1];
    if (!last) throw new Error('andJoin() before join()');

    const left = new Proxy({}, {
      get:(_,prop:string)=> new SqlField(this.ast.alias, prop)
    });
    const right = new Proxy({}, {
      get:(_,prop:string)=> new SqlField(last.alias, prop)
    });

    const exp = (this.ast as any).compileExp(fn(left, right));

    if (typeof last.on === 'string') {
      last.on = {
        logic:'And', isTrusted:false,
        subFilters:[
          { column:last.on, operator:'', value:null, isTrusted:true, subFilters:[] },
          exp
        ]
      };
    }
    else if (last.on.logic === 'And') {
      last.on.subFilters.push(exp);
    }
    else {
      last.on = {
        logic:'And', isTrusted:false,
        subFilters:[ last.on, exp ]
      };
    }

    return this;
  }

  // CTE
  with(name:string, fn:(c:any)=>any) {
    this.ast.with(name, fn);
    return this;
  }
  withRecursive(name:string, fn:(c:any)=>any) {
    this.ast.withRecursive(name, fn);
    return this;
  }

  // CTE JOIN
  joinCTE(name:string, alias:string, fn:(l:any,r:any)=>SqlExp | SqlExpChain) {
    this.ast.joinCTE(name, alias, fn);
    return this;
  }
  fullJoinCTE(name:string, alias:string, fn:(l:any,r:any)=>SqlExp | SqlExpChain) {
    this.ast.fullJoinCTE(name, alias, fn);
    return this;
  }

  // SUBQUERY
  subQuery(fn:(b:any)=>any) {
    return new SqlSubQuery(fn);
  }

  // APPLY
  apply(name:string, fn:(b:any)=>any) {
    this.ast.apply(name, fn);
    return this;
  }
  applyColumn(name:string, fn:(b:any)=>SqlField) {
    return this.ast.applyColumn(name, fn);
  }
  crossApply(app:any) {
    this.ast.crossApply(app);
    return this;
  }

  // GROUP BY
  groupBy(fn:(x:InvoiceLineSql)=>SqlField[]) {
    this.ast.addGroup(fn(this));
    return this;
  }

  // HAVING
  having(fn:(x:InvoiceLineSql)=>SqlExp | SqlExpChain) {
    this.ast.addHaving(fn(this));
    return this;
  }

  // ORDER
  orderBy(fn:(x:InvoiceLineSql)=>any[]) {
    this.ast.addOrder(fn(this));
    return this;
  }

  // UNION
  union(fn:(q:any)=>any) {
    this.ast.union(fn);
    return this;
  }
  unionAll(fn:(q:any)=>any) {
    this.ast.unionAll(fn);
    return this;
  }

  limit(n:number) { this.ast.take = n; return this; }
  offset(n:number) { this.ast.skip = n; return this; }

  build() {
    return this.ast.toQueryDescriptor();
  }
}
